//import {default as moment, Moment} from 'moment';
//import _date = moment.unitOfTime._date;

export class ChartDataRow {
    constructor(
        public readonly date: any,
        public readonly bufferG: number,
        public readonly bufferY: number,
        public readonly bufferR: number,
        public readonly safetyBuffer: number,
        public readonly actionBuffer: number,
        public readonly valueOut: number,
        public readonly valueIn: number,
        public readonly checkedBalance: number,
        public readonly noData: number,
        public readonly noDataBool: number,
        public readonly balance: number,
        public readonly targetStockLevel: number,
        public readonly packageValue: number,
        public readonly replenishmentTime: number,
        public readonly shelfQuantity: number,
        public readonly actionSafetyBuffer: number,
        public readonly maxQuantity: number,
        public readonly maxBuffer: number,
        public readonly minBuffer: number,
        public readonly qntOut1: number,
        public readonly qntOut2: number,
        public readonly discountQnt: number,
        public readonly realBuff: number,
        public readonly checkedSales: number,
        public readonly avgToReplenishment: number,
        public readonly transit: number,
        public readonly bufferGBT: number,
        public readonly bufferABT: number,
        public readonly bufferASBT: number,
        public readonly actionBalance: number,
        public readonly actionTransit: number,
        public readonly cancellation: number,
        public readonly lifeTime: number,
        public readonly need: number,
        public readonly transitNeed: number,
        public readonly order: number,
        public readonly balanceAmount: number,
        public readonly saleAmount: number,

        public readonly bufferGCount: number,
        public readonly safetyBufferCount: number,
        public readonly shelfQuantityCount: number,
        public readonly packageValueCount: number,
        public readonly replenishmentTimeCount: number,
        public readonly actionBufferCount: number,
        public readonly actionSafetyBufferCount: number,
        public readonly maxQuantityCount: number,
        public readonly maxBufferCount: number,
        public readonly minBufferCount: number,
        public readonly checkedSalesCount: number,
        public readonly targetStockLevelCount: number,
        public readonly checkedBalanceCount: number,
        public readonly cancellationCount: number,
        public readonly discountQntCount: number,
        public readonly balanceCount: number,
        public readonly valueInCount: number,
        public readonly valueOutCount: number,
        public readonly qntOut1Count: number,
        public readonly qntOut2Count: number,
        public readonly transitCount: number,
        public readonly bufferYCount: number,
        public readonly bufferRCount: number,
        public readonly avgToReplenishmentCount: number,
        public readonly lifeTimeCount: number,
        public readonly needCount: number,
        public readonly transitNeedCount: number,
        public readonly orderCount: number,
        public readonly balanceAmountCount: number,
        public readonly saleAmountCount: number,

        public readonly action: boolean,
        public readonly season: boolean,
        public readonly vacation: boolean,
        public readonly holiday: boolean,
        public readonly orderDay: boolean,
        public readonly deliveryDay: boolean,
        public readonly bufferGrowFixed: boolean,
        public readonly bufferDecreaseFixed: boolean,
        public readonly firstPriceItem: boolean,
        public readonly blockedToOrder: boolean

    ) {

    }
}





// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/chart-data-row.ts